
import { returnCheckList, stringContact } from './utilities-function';

export const PAYMENT_PROMOTION_CHECK_LIST = [
    {
        id: 1,
        check_list: [
            `<span>ราคาคอร์สเรียนที่แสดงบนเว็บไซต์เป็นราคาที่ผู้ให้บริการกำหนด ณ เวลาที่ผู้ใช้งานทำรายการสั่งซื้อ</span>`,
            `<span>ผู้ให้บริการอาจเปลี่ยนแปลงราคาคอร์สเรียนได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า ทั้งนี้ การเปลี่ยนแปลงราคาจะไม่มีผลย้อนหลังต่อรายการที่ผู้ใช้งานได้ชำระเงินและได้รับการยืนยันคำสั่งซื้อแล้ว</span>`,
            `<span>ราคาที่แสดงบนเว็บไซต์อาจรวมภาษีมูลค่าเพิ่มหรือค่าใช้จ่ายอื่นแล้ว หรืออาจมีค่าใช้จ่ายเพิ่มเติมตามที่ระบุไว้ในขั้นตอนการสั่งซื้อ</span>`,
            `<span>ผู้ใช้งานควรตรวจสอบรายละเอียดคอร์ส ราคา ส่วนลด และยอดชำระเงินก่อนยืนยันคำสั่งซื้อทุกครั้ง</span>`,
        ]
    },
    {
        id: 2,
        check_list: [
            `<span>บัตรเครดิตหรือบัตรเดบิต</span>`,
            `<span>การโอนเงินผ่านธนาคาร</span>`,
            `<span>QR Payment</span>`,
            `<span>Mobile Banking</span>`,
            `<span>ช่องทางการชำระเงินอื่นที่ผู้ให้บริการกำหนด</span>`,
        ]
    },
    {
        id: 3,
        check_list: []
    },
    {
        id: 4,
        check_list: []
    },
    {
        id: 5,
        check_list: [
            `<span>ระยะเวลาที่โปรโมชั่นมีผล</span>`,
            `<span>คอร์สที่เข้าร่วมรายการ</span>`,
            `<span>จำนวนสิทธิ์ที่สามารถใช้ได้</span>`,
            `<span>ยอดซื้อขั้นต่ำ</span>`,
            `<span>ส่วนลดสูงสุด</span>`,
            `<span>จำนวนครั้งที่สามารถใช้สิทธิ์ได้</span>`,
            `<span>เงื่อนไขการใช้ร่วมกับโปรโมชั่นอื่น</span>`,
        ]
    },
    {
        id: 6,
        check_list: []

    },
    {
        id: 7,
        check_list: []
    },
    {
        id: 8,
        check_list: []

    },
    {
        id: 9,
        check_list: []
    },
    {
        id: 10,
        check_list: [
            `<span>การใช้คูปองผิดวัตถุประสงค์</span>`,
            `<span>การใช้ช่องโหว่ของระบบ</span>`,
            `<span>การใช้บัญชีหลายบัญชีเพื่อรับสิทธิ์โดยไม่เป็นไปตามเงื่อนไข</span>`,
            `<span>การใช้รหัสส่วนลดที่ไม่ได้รับอนุญาต</span>`,
            `<span>การกระทำอื่นใดที่มีลักษณะเป็นการทุจริตหรือหลีกเลี่ยงเงื่อนไขของโปรโมชั่น</span>`,
        ]
    },
    {
        id: 11,
        check_list: []
    },
    {
        id: 12,
        check_list: []
    },
    {
        id: 13,
        check_list: []
    },
    {
        id: 14,
        check_list: []
    },
    {
        id: 15,
        check_list: []
    },
    {
        id: 16,
        check_list: []
    },
]

export const PAYMENT_PROMOTION = [
    {
        id: 1,
        name: 'ราคาและค่าบริการ',
        content: `
        ${returnCheckList({ file_data: PAYMENT_PROMOTION_CHECK_LIST, check_list_id: 1, bullet: 'number' })}
        `
    },
    {
        id: 2,
        name: 'ช่องทางการชำระเงิน',
        content: `
        <p class="mb-0">ผู้ให้บริการอาจรองรับช่องทางการชำระเงิน เช่น</p>
        ${returnCheckList({ file_data: PAYMENT_PROMOTION_CHECK_LIST, check_list_id: 2 })}
        <p class="mb-0">ช่องทางการชำระเงินที่สามารถใช้งานได้จะแสดงในขั้นตอนการสั่งซื้อ</p>
        `
    },
    {
        id: 3,
        name: 'การยืนยันการชำระเงิน',
        content: `  
        เมื่อการชำระเงินได้รับการยืนยันจากระบบแล้ว รายการสั่งซื้อจะถือว่าเสร็จสมบูรณ์ และผู้ใช้งานจะได้รับสิทธิ์เข้าถึงคอร์สตามเงื่อนไขของคอร์สนั้น
        ในกรณีที่ระบบยังไม่สามารถยืนยันการชำระเงินได้ ผู้ใช้งานอาจยังไม่ได้รับสิทธิ์เข้าถึงคอร์สจนกว่าการชำระเงินจะได้รับการตรวจสอบและยืนยันเรียบร้อยแล้ว
        `
    },
    {
        id: 4,
        name: 'การชำระเงินไม่สำเร็จ',
        content: `
        หากการชำระเงินไม่สำเร็จ ผู้ใช้งานสามารถดำเนินการชำระเงินใหม่ผ่านช่องทางที่ระบบรองรับ<br/>
        หากมีการหักเงินจากบัญชีของผู้ใช้งานแล้ว แต่สถานะการสั่งซื้อยังไม่สำเร็จ ผู้ใช้งานควรติดต่อฝ่ายบริการลูกค้าพร้อมข้อมูลอ้างอิงรายการชำระเงิน เพื่อให้ผู้ให้บริการตรวจสอบ
        `
    },
    {
        id: 5,
        name: 'โปรโมชั่นและส่วนลด',
        content: `
        <p class="mb-0">ผู้ให้บริการอาจจัดโปรโมชั่น ส่วนลด คูปอง หรือสิทธิประโยชน์ต่าง ๆ ตามช่วงเวลาหรือเงื่อนไขที่กำหนด</p>
        <p class="mb-0">โปรโมชั่นแต่ละรายการอาจมีเงื่อนไขแตกต่างกัน เช่น</p>
        ${returnCheckList({ file_data: PAYMENT_PROMOTION_CHECK_LIST, check_list_id: 5 })}
        <p class="mb-0">ผู้ใช้งานควรตรวจสอบเงื่อนไขของโปรโมชั่นก่อนทำรายการทุกครั้ง</p>

        `
    },
    {
        id: 6,
        name: 'การใช้คูปองและรหัสส่วนลด',
        content: `
        ในกรณีที่ระบบรองรับคูปองหรือรหัสส่วนลด ผู้ใช้งานต้องกรอกรหัสส่วนลดที่ถูกต้องและเป็นไปตามเงื่อนไขที่กำหนด
        ส่วนลดจะถูกนำไปคำนวณตามเงื่อนไขของโปรโมชั่น และผู้ใช้งานควรตรวจสอบยอดชำระเงินหลังหักส่วนลดก่อนยืนยันคำสั่งซื้อ
        คูปองหรือรหัสส่วนลดที่หมดอายุ ถูกยกเลิก หรือไม่เป็นไปตามเงื่อนไข จะไม่สามารถนำมาใช้งานได้
        `
    },
    {
        id: 7,
        name: 'การใช้โปรโมชั่นร่วมกัน',
        content: `
            เว้นแต่จะมีการระบุไว้เป็นอย่างอื่น โปรโมชั่น ส่วนลด หรือคูปองแต่ละรายการไม่สามารถใช้ร่วมกับโปรโมชั่นอื่นได้
            ผู้ให้บริการขอสงวนสิทธิ์ในการกำหนดหรือเปลี่ยนแปลงเงื่อนไขการใช้โปรโมชั่นตามความเหมาะสม
        `
    },
    {
        id: 8,
        name: 'โปรโมชั่นที่มีจำนวนจำกัด',
        content: `
       โปรโมชั่นบางรายการอาจมีจำนวนสิทธิ์จำกัด และให้สิทธิ์แก่ผู้ใช้งานตามลำดับการทำรายการจนกว่าสิทธิ์จะหมด
ผู้ให้บริการไม่รับประกันว่าผู้ใช้งานจะได้รับสิทธิ์โปรโมชั่น แม้ว่าจะเข้าชมหน้าโปรโมชั่นหรือเห็นโปรโมชั่นบนเว็บไซต์ก็ตาม เว้นแต่ผู้ใช้งานจะดำเนินการตามเงื่อนไขและได้รับการยืนยันสิทธิ์จากระบบแล้ว
        `
    },
    {
        id: 9,
        name: 'การยกเลิกหรือเปลี่ยนแปลงโปรโมชั่น',
        content: `
        ผู้ให้บริการอาจยกเลิก ระงับ หรือเปลี่ยนแปลงโปรโมชั่น รวมถึงเงื่อนไขของโปรโมชั่นได้ตามความเหมาะสม
        การเปลี่ยนแปลงดังกล่าวจะไม่มีผลย้อนหลังต่อรายการที่ผู้ใช้งานได้ทำรายการและชำระเงินสำเร็จตามเงื่อนไขของโปรโมชั่นแล้ว
        `
    },
    {
        id: 10,
        name: 'การใช้โปรโมชั่นโดยไม่ถูกต้อง',
        content: `
       <p class="mb-0">ผู้ให้บริการขอสงวนสิทธิ์ในการยกเลิกส่วนลดหรือสิทธิประโยชน์ที่เกิดจากการใช้โปรโมชั่นโดยไม่เป็นไปตามเงื่อนไข เช่น</p>
        ${returnCheckList({ file_data: PAYMENT_PROMOTION_CHECK_LIST, check_list_id: 10 })}
        <p class="mb-0">ในกรณีดังกล่าว ผู้ให้บริการอาจระงับหรือยกเลิกรายการสั่งซื้อหรือสิทธิประโยชน์ที่เกี่ยวข้องตามความเหมาะสม</p>
        `
    },
    {
        id: 11,
        name: 'การคืนเงิน',
        content: `
        <p class="mb-0">เมื่อผู้ใช้งานยืนยันคำสั่งซื้อและชำระเงินเรียบร้อยแล้ว ผู้ใช้งานไม่สามารถยกเลิกคำสั่งซื้อหรือขอคืนเงินได้ เว้นแต่กรณีที่ผู้ให้บริการกำหนดเป็นอย่างอื่น หรือเป็นกรณีที่เกิดจากความผิดพลาดของผู้ให้บริการหรือระบบ
            <br/>โปรโมชั่น ส่วนลด หรือคูปองที่ใช้กับรายการสั่งซื้อจะไม่มีมูลค่าเป็นเงินสด และไม่สามารถแลกเปลี่ยนเป็นเงินสดได้
            ในกรณีที่มีการอนุมัติคืนเงิน จำนวนเงินที่ได้รับคืนอาจเป็นไปตามเงื่อนไขและวิธีการที่ผู้ให้บริการกำหนด
        </p>
        `
    },
    {
        id: 12,
        name: 'ความผิดพลาดด้านราคาและโปรโมชั่น',
        content: `
        <p class="mb-0">
        หากเกิดข้อผิดพลาดเกี่ยวกับราคา ส่วนลด หรือเงื่อนไขโปรโมชั่นจากระบบ ผู้ให้บริการขอสงวนสิทธิ์ในการแก้ไขข้อมูลดังกล่าว
        ในกรณีที่รายการสั่งซื้อยังไม่ได้รับการยืนยัน ผู้ให้บริการอาจยกเลิกรายการที่เกิดจากข้อผิดพลาดดังกล่าว และจะแจ้งให้ผู้ใช้งานทราบตามช่องทางที่เหมาะสม
        </p>
        `
    },
    {
        id: 13,
        name: 'การเปลี่ยนแปลงนโยบาย',
        content: `
            <p class="mb-0">
                ผู้ให้บริการอาจปรับปรุงหรือเปลี่ยนแปลงนโยบายการชำระเงินและโปรโมชั่นเป็นครั้งคราว เพื่อให้สอดคล้องกับการให้บริการ เทคโนโลยี และกฎหมายที่เกี่ยวข้อง
                <br/>นโยบายฉบับปรับปรุงจะมีผลตั้งแต่วันที่ระบุไว้ในนโยบาย
            </p>
                `
    },
    {
        id: 14,
        name: 'ติดต่อเรา',
        content: `หากมีคำถามเกี่ยวกับข้อตกลงและเงื่อนไข สามารถติดต่อได้ที่
        ${stringContact()}`
    },

]



